module.exports = __webpack_public_path__ + "static/img/ent-detail-93.9b344fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-93.jpg
// module id = +hrQ
// module chunks = 52